<template>
  <div class="flex flex-col items-center">
    <div v-if="value" class="text-center">
      <div class="shadow">
        <img
          :src="value"
          alt=""
          class="cursor-pointer"
          @click="$modal.show('thumbPreview')"
        />
        <button
          class="text-red-light px-2 hover:text-red-dark my-1 text-sm"
          @click="$emit('input', '')"
        >
          Remove Image
        </button>
      </div>
      <div v-if="value" class="text-center text-xs mt-1 text-grey-dark">
        Click image to expand
      </div>
    </div>
    <div v-if="showCustomUploader" class="w-full text-center">
      <S3FileUploader
        :serverUrl="serverUrl"
        :category="context_type"
        class="text-center w-full"
        @FILE_UPLOAD_SUCCESS="handleImageUpload"
      >
        <slot name="dropAreaContent">
          <span class="material-icons text-3xl text-grey">
            add_photo_alternate
          </span>
          <div class="text-base font-bold">Drop image here</div>
          <span class="text-sm">or click here to select (1280px x 720px)</span>
        </slot>
      </S3FileUploader>
      <div class="mt-2 text-sm">
        You can upload your own thumbnail or auto generate
      </div>
    </div>
    <BaseButton
      btnStyle="blue"
      type="button"
      :disabled="!text"
      class="px-2 py-1 rounded mt-1 flex justify-center items-center text-sm"
      @click="handleGenerateClick"
    >
      <span class="material-icons text-lg mr-1">
        {{
          value
            ? "flip_camera_ios"
            : generatingThumb
            ? "pending"
            : "add_a_photo"
        }}
      </span>
      {{
        value
          ? "Regenerate Thumbnail"
          : generatingThumb
          ? "Please wait..."
          : "Generate Thumbnail"
      }}
    </BaseButton>
    <VModal name="thumbPreview" width="960" height="540">
      <img :src="value" alt="" />
    </VModal>
  </div>
</template>

<script>
import S3FileUploader from "@edyst/shared-components/src/components/S3FileUploader"
import { generateThumbnail } from "@/apis/thumbnail"
import siteConfig from "@/utils/siteConfig"
import BaseButton from "@/components/Base/BaseButton"

export default {
  components: {
    BaseButton,
    S3FileUploader,
  },
  props: {
    text: {
      type: String,
      required: true, // text to be written on the image
    },
    context_type: {
      type: String,
      required: true, // default_cohort/qb_cohort/contest/liveclass
    },
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      generatingThumb: false,
    }
  },
  computed: {
    serverUrl: () => `${siteConfig.siteURL}uploads/public`,
    showCustomUploader() {
      return !this.value && !this.generatingThumb
    },
  },
  methods: {
    handleGenerateClick() {
      if (!this.text) {
        this.$noty.error(
          "Please enter valid text which will be written on the image"
        )
        return
      }

      // clear already selected value
      this.$emit("input", "")

      this.generatingThumb = true
      generateThumbnail({
        text: this.text,
        context_type: this.context_type,
      })
        .then(res => {
          this.$emit("input", res.data.file_url)
        })
        .catch(error => {
          console.error(error)
          this.$noty.error("Failed to generate the thumbnail. Please try again")
        })
        .finally(() => {
          this.generatingThumb = false
        })
    },
    handleImageUpload(awsImageUrl) {
      if (awsImageUrl) {
        this.$emit("input", awsImageUrl)
        this.$noty.success("Image upload successful")
      }
    },
  },
}
</script>
